module.exports = __webpack_public_path__ + "static/media/tourism.e0349dd0.svg";